import { HttpContextToken } from '@angular/common/http';

export const PROPAGATE_HTTP_ERRORS = new HttpContextToken<boolean>(() => false);
